const sampleQueue = [
  { id: 'RAD-001', patientName: 'Giorgi Beridze', referringDoctor: 'Dr. Lomidze', imagingType: 'CBCT', targetArea: '#14, #15', clinicalQuestion: 'Evaluate bone density for implant placement', urgency: 'urgent', status: 'pending', createdAt: 'Mar 19, 2026 08:30' },
  { id: 'RAD-002', patientName: 'Nino Kapanadze', referringDoctor: 'Dr. Kvaratskhelia', imagingType: 'Panoramic', targetArea: 'Full Mouth', clinicalQuestion: 'Comprehensive evaluation before orthodontic treatment', urgency: 'normal', status: 'inProgress', createdAt: 'Mar 19, 2026 09:15' },
  { id: 'RAD-003', patientName: 'Davit Gelashvili', referringDoctor: 'Dr. Beridze', imagingType: 'Periapical', targetArea: '#30', clinicalQuestion: 'Suspected periapical abscess, rule out fracture', urgency: 'urgent', status: 'pending', createdAt: 'Mar 19, 2026 10:00' },
  { id: 'RAD-004', patientName: 'Mariam Tsiklauri', referringDoctor: 'Dr. Lomidze', imagingType: 'Cephalometric', targetArea: 'Lateral', clinicalQuestion: 'Pre-orthodontic cephalometric analysis', urgency: 'normal', status: 'completed', createdAt: 'Mar 18, 2026 14:20' },
  { id: 'RAD-005', patientName: 'Ana Javakhishvili', referringDoctor: 'Dr. Kvaratskhelia', imagingType: 'CBCT', targetArea: '#3, #4, #5', clinicalQuestion: 'Sinus proximity assessment before extraction', urgency: 'normal', status: 'completed', createdAt: 'Mar 18, 2026 11:45' },
  { id: 'RAD-006', patientName: 'Luka Mchedlishvili', referringDoctor: 'Dr. Beridze', imagingType: 'Periapical', targetArea: '#19', clinicalQuestion: 'Post root canal treatment follow-up', urgency: 'normal', status: 'inProgress', createdAt: 'Mar 19, 2026 07:50' }
]

export const radiology = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'radiology', radiologyTab: s.root.radiologyTab || 'queue', radiologyQueue: s.root.radiologyQueue || sampleQueue, radiologyFilter: s.root.radiologyFilter || 'all' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y', flex: '1', overflow: 'auto',
    TopBar: {},

    ContentArea: {
      flow: 'y', gap: 'B', padding: 'B', flex: '1',
      '@mobileL': { padding: 'A' },

      // ---- STATS BAR ----
      StatsBar: {
        flow: 'x', gap: 'Z', flexWrap: 'wrap', marginBottom: 'Z',

        PendingStat: {
          flow: 'x', gap: 'Y', align: 'center flex-start', padding: 'Z A', round: 'Z', background: 'amber.15', flex: '1', minWidth: '140px',
          Icon: { text: '\u23F3', fontSize: 'A' },
          Info: {
            flow: 'y',
            Count: { text: (el, s) => String(((s.root.radiologyQueue || []).filter(r => r.status === 'pending')).length), fontSize: 'B', fontWeight: '700', color: 'amber' },
            Label: { text: '{{ pending | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
          }
        },
        InProgressStat: {
          flow: 'x', gap: 'Y', align: 'center flex-start', padding: 'Z A', round: 'Z', background: 'blue.15', flex: '1', minWidth: '140px',
          Icon: { text: '\uD83D\uDD04', fontSize: 'A' },
          Info: {
            flow: 'y',
            Count: { text: (el, s) => String(((s.root.radiologyQueue || []).filter(r => r.status === 'inProgress')).length), fontSize: 'B', fontWeight: '700', color: 'blue' },
            Label: { text: '{{ inProgress | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
          }
        },
        CompletedStat: {
          flow: 'x', gap: 'Y', align: 'center flex-start', padding: 'Z A', round: 'Z', background: 'teal.15', flex: '1', minWidth: '140px',
          Icon: { text: '\u2705', fontSize: 'A' },
          Info: {
            flow: 'y',
            Count: { text: (el, s) => String(((s.root.radiologyQueue || []).filter(r => r.status === 'completed')).length), fontSize: 'B', fontWeight: '700', color: 'teal' },
            Label: { text: '{{ completedToday | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
          }
        }
      },

      // ---- TAB NAV ----
      RadiologyNav: {
        flow: 'x', gap: 'Z', borderBottom: '1px solid inkBorder', paddingBottom: 'Y',
        TabNewReferral: { text: '{{ newReferral | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: (el, s) => s.root.radiologyTab === 'newReferral' ? 'teal' : 'inkMuted', borderBottom: (el, s) => s.root.radiologyTab === 'newReferral' ? '2px solid teal' : '2px solid transparent', onClick: (e, el, s) => s.root.update({ radiologyTab: 'newReferral' }) },
        TabQueue: { text: '{{ queue | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: (el, s) => s.root.radiologyTab === 'queue' ? 'teal' : 'inkMuted', borderBottom: (el, s) => s.root.radiologyTab === 'queue' ? '2px solid teal' : '2px solid transparent', onClick: (e, el, s) => s.root.update({ radiologyTab: 'queue' }) }
      },

      // ---- NEW REFERRAL VIEW ----
      NewReferralView: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.radiologyTab === 'newReferral',
        maxWidth: '640px',
        RadiologyReferralForm: {}
      },

      // ---- QUEUE VIEW ----
      QueueView: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.radiologyTab === 'queue',

        QueueFilterBar: {
          flow: 'x', gap: 'Y', flexWrap: 'wrap', paddingBottom: 'Z',
          AllPill: { tag: 'button', text: '{{ allFilter | polyglot }}', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none', background: (el, s) => s.root.radiologyFilter === 'all' ? 'teal' : 'inkSurface', color: (el, s) => s.root.radiologyFilter === 'all' ? 'ink' : 'inkMuted', onClick: (e, el, s) => s.root.update({ radiologyFilter: 'all' }) },
          PendingPill: { tag: 'button', text: '{{ pending | polyglot }}', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none', background: (el, s) => s.root.radiologyFilter === 'pending' ? 'amber' : 'inkSurface', color: (el, s) => s.root.radiologyFilter === 'pending' ? 'ink' : 'inkMuted', onClick: (e, el, s) => s.root.update({ radiologyFilter: 'pending' }) },
          InProgressPill: { tag: 'button', text: '{{ inProgress | polyglot }}', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none', background: (el, s) => s.root.radiologyFilter === 'inProgress' ? 'blue' : 'inkSurface', color: (el, s) => s.root.radiologyFilter === 'inProgress' ? 'white' : 'inkMuted', onClick: (e, el, s) => s.root.update({ radiologyFilter: 'inProgress' }) },
          CompletedPill: { tag: 'button', text: '{{ completed | polyglot }}', padding: 'Y Z', round: 'C', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none', background: (el, s) => s.root.radiologyFilter === 'completed' ? 'teal' : 'inkSurface', color: (el, s) => s.root.radiologyFilter === 'completed' ? 'ink' : 'inkMuted', onClick: (e, el, s) => s.root.update({ radiologyFilter: 'completed' }) }
        },

        QueueList: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 'A',
          children: (el, s) => {
            const queue = s.root.radiologyQueue || []
            const filter = s.root.radiologyFilter || 'all'
            return filter === 'all' ? queue : queue.filter(r => r.status === filter)
          },
          childrenAs: 'state',
          childExtends: 'RadiologyQueueCard'
        }
      }
    }
  }
}
